<template>
  <div :class="componentClassName">
    <template v-for="(item, index) in statusList" :key="index">
      <div class="a-calling-response-status__row">
        <span class="a-calling-response-status__label">{{ item.label }}</span>
        <span class="a-calling-response-status__status">{{ item.value }}</span>
      </div>
      <div v-if="shouldShowSeparator(index)" class="a-calling-response-status__row-separator" />
    </template>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';

export default {
  name: 'a-calling-response-status',
  props: {
    class: {
      type: String,
      default: '',
    },
    statusList: {
      type: Array,
      default: new Array(0),
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-calling-response-status');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    shouldShowSeparator(index) {
      return this.statusList.length > 1 && index < this.statusList.length - 1;
    },
  },
};
</script>
